import { ERROR } from "../../constants";

import { SYNCHRO_GET_PARAMETERS, SYNCHRO_ADD_PARAMETERS } from "../parameter/parameterConstants";
import { SYNCHRO_GET_ACTIVE_DAY } from "../day/dayConstants";
import { SYNCHRO_GET_ACTIVE_USER } from "../users/usersConstants";
import { SYNCHRO_GET_API_ACTIVITY_TYPES, DELETE_ALL_ACTIVITY_TYPE } from "../activityTypes/activityTypesConstants";
import { SYNCHRO_GET_API_REPORT, DELETE_ALL_REPORT } from "../activityReport/activityReportConstants";

export { ERROR };

export { SYNCHRO_ADD_PARAMETERS };
export { SYNCHRO_GET_PARAMETERS };
export { SYNCHRO_GET_ACTIVE_DAY };
export { SYNCHRO_GET_ACTIVE_USER };
export { SYNCHRO_GET_API_ACTIVITY_TYPES };
export { DELETE_ALL_ACTIVITY_TYPE };
export { SYNCHRO_GET_API_REPORT };
export { DELETE_ALL_REPORT };

export const WAITING_REQUESTS_SYNCHRO_CODE = "WAITING_REQUESTS_SYNCHRO_CODE";
export const USER_SYNCHRO_CODE = "USER_SYNCHRO_CODE";
export const ACTIVITY_TYPE_SYNCHRO_CODE = "ACTIVITY_TYPE_SYNCHRO_CODE";
export const PRODUCT_CATEGORIES_SYNCHRO_CODE = "PRODUCT_CATEGORIES_SYNCHRO_CODE";
export const SUBCONTRACTORS_SYNCHRO_CODE = "SUBCONTRACTORS_SYNCHRO_CODE";
export const WORK_ORDERS_SYNCHRO_CODE = "WORK_ORDERS_SYNCHRO_CODE";
export const SYNCHO_PERIODS_SYNCHRO_CODE = "SYNCHO_PERIODS_SYNCHRO_CODE";
export const WHAT_S_UP_SYNCHRO_CODE = "WHAT_S_UP_SYNCHRO_CODE";
export const SITE_MONITORING_SYNCHRO_CODE = "SITE_MONITORING_SYNCHRO_CODE";
export const NB_EPI_TO_CHECK_SYNCHRO_CODE = "NB_EPI_TO_CHECK_SYNCHRO_CODE";
export const NB_WAITING_INTERVIEWS_CODE = "NB_WAITING_INTERVIEWS_CODE";

export const DEFAULT_SYNCHRO_PERIOD_IN_MINUTES = 5;
